﻿

$(function () {

    if ($('#query').length > 0) {
        LoadSearchResult(SearchPagination());
    }

    $('#btn_search_load_more').click(function () {
        LoadSearchResult(SearchPagination()
        );
    });

    function LoadSearchResult(searchPagination) {
        let query = $('#query').val();
        let year = $('#selectedYear').val() != '' ? $('#selectedYear').val() : '2000';
        let selectedPageType = $('#selectedPageType').val() != '' ? $('#selectedPageType').val().split(',') : null;
        let selectedCategory = $('#selectedCategory').val() != '' ? $('#selectedCategory').val().split(',') : null;
        let orderBy = $('#ddlOrderBy').val();
        let searchParams = {
            Query: query, Page: searchPagination, PageSize: $('#numberOfItems').val(), PublishYear: year,
            PageType: selectedPageType, Category: selectedCategory, OrderBy: orderBy
        };

        $('#usedQuery').text('"' + query + '"');

        $.ajax({
            type: 'POST',
            url: '/api/content/search/result',
            dataType: 'json',
            data: JSON.stringify(searchParams),
            contentType: 'application/json',
            success: function (data) {

                if (searchPagination == 1) {
                    $('section.lm__searchresult').html('');
                }

                $('.YearFacets').html('');
                $('.ContentTypes').html('');
                SearchResult(data);
                $('.search-results-found').css('display', 'inline');

                let pagination = parseInt(searchPagination) + 1;
                $('#searchPagination').val(pagination);

                if (data.Hits.length < $('#numberOfItems').val()) {
                    $('#btn_search_load_more').attr('disabled', true);
                } else {
                    $('#btn_search_load_more').attr('disabled', false);
                }
            },
            error: function (data) {
                console.log(data.responseText);
            }
        });

    }

    $('#query').keypress(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);

        if (keycode == '13') {
            if ($(this).val().length > 3) {
                let url = document.location.href.split('?')[0];
                url = url + '?query=' + $(this).val();
                document.location.href = url;
            }
        }
    });

    function ToJavaScriptDate(value) {
        let dt = new Date(value);
        return dt.getDate() + "/" + (dt.getMonth() + 1 * 1) + "/" + dt.getFullYear();
    }

    function SearchResult(data) {

        $('#resultCount').text(data.TotalCount);

        $.each(data.Hits, function (key, page) {
            $('section.lm__searchresult').append(
                $('<div class="lm-search-item">').append(
                    $('<a href="' + page.Url + '" target="' + (page.Type == "Tiedosto" ? "_blank" : "_self") + '">')
                        .append($('<h4 class="search-result-title">').text(page.Title))
                        .append($('<div class="search-result-date">').text(ToJavaScriptDate(page.Created)))
                        .append($('<div class="search-result-type">').text(page.Type))
                )
                    .append($('<p class="article-summary-description">').text(page.Text))
            );
        });

        $.each(data.YearFacets, function (key, facet) {
            var facetItems = $('<ul>');

            $.each(facet.FacetTags, function (key, FacetTag) {
                facetItems.append($('<li>')
                    .append($('<a id=' + FacetTag.Name + ' class="lm__link facetfilter year ' + (FacetTag.Selected ? 'selected' : '') + '">').text(FacetTag.Name + ' (' + FacetTag.Count + ')')
                        .append($('<i style="display:' + (FacetTag.Selected ? 'inline' : 'none') + ';" class="glyphicon glyphicon-remove"></i>'))
                    ));
            });

            $('.YearFacets').append($('<h4>').text(facet.Name))
                .append(facetItems);
        });

        $.each(data.ContentTypes, function (key, facet) {
            var facetItems = $('<ul>');

            $.each(facet.FacetTags, function (key, FacetTag) {
                facetItems.append($('<li>')
                    .append($('<a id=' + FacetTag.Id + ' class="lm__link facetfilter pagetype ' + (FacetTag.Selected ? 'selected' : '') + '">').text(FacetTag.Name)
                        .append($('<i style="display:' + (FacetTag.Selected ? 'inline' : 'none') + ';" class="glyphicon glyphicon-remove"></i>'))
                    ));
            });

            $('.ContentTypes').append($('<h4>').text(facet.Name))
                .append(facetItems);
        });

        $.each(data.Categories, function (key, facet) {
            var facetItems = $('<ul>');

            $.each(facet.FacetTags, function (key, FacetTag) {
                facetItems.append($('<li>')
                    .append($('<a id=' + FacetTag.Id + ' class="lm__link facetfilter category ' + (FacetTag.Selected ? 'selected' : '') + '">').text(FacetTag.Name)
                        .append($('<i style="display:' + (FacetTag.Selected ? 'inline' : 'none') + ';" class="glyphicon glyphicon-remove"></i>'))
                    ));
            });

            $('.ContentTypes').append($('<h4>').text(facet.Name))
                .append(facetItems);
        });
    }

    $('#ddlOrderBy').change(function () {
        $('#searchPagination').val('1');
        LoadSearchResult(SearchPagination());
    });

    $(document).on('click', '.facetfilter', function () {

        if ($(this).hasClass('selected')) {

            if ($(this).hasClass('year')) {
                $('#selectedYear').val('');
            }
            else if ($(this).hasClass('pagetype')) {
                $('#selectedPageType').val('');
            }
            else if ($(this).hasClass('category')) {
                $('#selectedCategory').val('');
            }
        }
        else {

            if ($(this).hasClass('year')) {
                $('#selectedYear').val($(this).attr('id'));
            }
            else if ($(this).hasClass('pagetype')) {
                $('#selectedPageType').val($(this).attr('id'));
            }
            else if ($(this).hasClass('category')) {
                $('#selectedCategory').val($(this).attr('id'));
            }
        }

        $('#searchPagination').val('1');
        LoadSearchResult(SearchPagination());
    });

    function SearchPagination() {
        var searchPagination = 1;

        if ($('#searchPagination').val() !== null) {
            searchPagination = $('#searchPagination').val();
        }

        return searchPagination;
    }

    $('#txtSearchSuggestion').mouseover(function () {
        $("#ulSearchSuggestions").empty();
    });

    $('#txtSearchSuggestion').keyup(function (event) {
        var search = $(this).val();

        if (search.length > 2) {
            var keycode = (event.keyCode ? event.keyCode : event.which);

            if (keycode == '13') {
                let url = '/agrodesk/kotisivu/haku?query=' + search;
                window.location.href = url;
            }
            else {

                $.ajax({
                    url: '/api/content/search/suggestions?query=' + search + '&count=50',
                    type: 'GET',
                    dataType: 'json',
                    success: function (response) {

                        var len = response.length;
                        $("#ulSearchSuggestions").empty();

                        for (var i = 0; i < len; i++) {
                            var resutlGroupArr = response[i];
                            var len2 = resutlGroupArr.length < 4 ? resutlGroupArr.length : 4;
                            $("#ulSearchSuggestions").append('<li><b>' + resutlGroupArr[0].PageContentType + ' (' + len2 + ')' + '</b></li>');

                            for (var j = 0; j < len2; j++) {
                                var url = resutlGroupArr[j].Url;
                                var name = resutlGroupArr[j].Name;
                                $("#ulSearchSuggestions").append('<li> <a class="lm__link" href="' + url + '" >' + name + '</a></li>');
                            }
                        }

                        $("#ulSearchSuggestions").append('<li class="gotosearch"> <a href="/agrodesk/kotisivu/haku/?query=' + search +
                            '" class="lm__link">Näytä kaikki hakutulokset</a></li>');
                    }
                });
            }
        }
    });
});